import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

// Uneven rotation: 0° → 180° → 270° → 360° (faster first third, then slower)
const rotateUneven = keyframes`
  0% { transform: rotate(0deg); }
  33.333% { transform: rotate(180deg); }
  66.666% { transform: rotate(270deg); }
  100% { transform: rotate(360deg); }
`;

// Style the container with optional positioning
const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${(props) => SIZE_MAP[props.size] || '24px'};
    height: ${(props) => SIZE_MAP[props.size] || '24px'};
`;

// Style the spinner with animation
const SpinnerSvg = styled.svg`
    width: 100%;
    height: 100%;
    animation: ${rotateUneven} ${(props) => props.speed || '1s'} linear infinite;
    transform-box: fill-box;
    transform-origin: center;
`;
const SIZE_MAP = {
    small: '16px',
    medium: '24px',
    large: '32px',
};

/**
 * Loader component that displays a rotating spinner
 * @param {Object} props
 * @param {string} props.size - Size of the spinner (e.g., small, medium, large)
 * @param {string} props.speed - Animation duration (e.g., '1s', '800ms')
 * @param {Object} props.style - Additional styles to apply to the container
 */
const Spinner = ({ size = 'medium', speed = '1s' }) => {
    return (
        <LoaderContainer size={size}>
            <SpinnerSvg
                className="lyt-spinner-svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 54 54"
                fill="none"
                speed={speed}>
                <path
                    d="M3.01489 27.8376C2.83801 22.7723 4.26921 17.7812 7.10337 13.5793C9.93753 9.37753 14.0291 6.18081 18.7918 4.44735C23.5544 2.71389 28.7436 2.53268 33.6156 3.92969C38.4875 5.32671 42.7922 8.23022 45.9125 12.2241C49.0329 16.218 50.8088 21.0972 50.9857 26.1624C51.1625 31.2276 49.7313 36.2188 46.8972 40.4206C44.063 44.6224 39.9714 47.8191 35.2088 49.5526C30.4461 51.2861 25.2569 51.4673 20.385 50.0703"
                    stroke="#D9D9D9"
                    strokeWidth="6"
                />
                <path
                    d="M3.01489 27.8376C2.83801 22.7723 4.26921 17.7812 7.10337 13.5793C9.93753 9.37753 14.0291 6.18081 18.7918 4.44735C23.5544 2.71389 28.7436 2.53268 33.6156 3.92969C38.4875 5.32671 42.7922 8.23022 45.9125 12.2241"
                    stroke="#2D2D2D"
                    strokeWidth="6"
                />
            </SpinnerSvg>
        </LoaderContainer>
    );
};
Spinner.propTypes = {
    size: PropTypes.string,
    speed: PropTypes.string,
};
export default Spinner;
